import React from "react";
import MaterialItem from "./MaterialItem";

export default function WeekItem(props) {
  return (
    <div class="card card-bottom-tabs m-t-10">
      <div class="card-block">
        <h4 class="card-title m-t-0">
        Week {props.weekNo}
        </h4>
        <div class="row">
     {props.assignments.length==0? 
     <div class="col-12">
      <div class="alert alert-yellow  fade show">
          There is no content available in this week.
          
        </div>
      </div>
     :
     props.assignments.map((item,index) => (
       
        <MaterialItem {...item} key={index} />
      
    ))
    
     }
     </div>




      </div>
    </div>

  );
}



// WEBPACK FOOTER //
// ./src/pages/course/E-Learning/WeekItem.js